import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, dark = false }) => (
  <div className="flex items-center gap-3">
    <span className={`h-px w-10 ${dark ? "bg-[#8DA37F]" : "bg-[#8DA37F]"}`} />
    <span
      className={`text-xs tracking-[0.25em] uppercase font-medium ${
        dark ? "text-[#8DA37F]" : "text-[#6b7f5e]"
      }`}
    >
      {children}
    </span>
  </div>
);
